import { useState, useEffect } from "react";
import { useFormik } from "formik";
import {
  Stack,
  Button,
  Container,
  Typography,
  TableCell,
  MenuItem,
  Avatar,
} from "@mui/material";
import Iconify from "src/components/iconify";
import { RouterLink } from "src/routes/components";
import { Link } from "react-router-dom";
import { useTableLoadRecords } from "src/hooks/use-load-table-records";
import Label from "src/components/label";
import { CustomTable } from "src/components/custom-table/custom-table";
import { CustomTableRow } from "src/components/custom-table/custom-table-row";
import { useDispatch, useSelector } from "react-redux";
import { updateSearch } from "src/redux/slice/search-slice";
import { sliceName } from "src/utils/slice-name";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { avatarHover, textHover } from "src/utils/hover-effect";
import { dateFormatter } from "src/utils/date-formatter";
import dayjs from "dayjs";

const searchInitialValues = {
  search: "",
  page: 0,
  order_by: "created_at",
  order_type: "desc",
  limit: parseInt(process.env.REACT_APP_PAGINATION_LIMIT, 10),
};
export default function StaticUrls() {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.search);
  const loadTableRecords = useTableLoadRecords();
  const searchPageId = "customer-management";
  const [state, setState] = useState({
    records: [],
    loading: false,
    tcount: 0,
  });
  const instanceSearch = useFormik({
    initialValues: searchInitialValues,
    onSubmit: (values, actions) => {
      dispatch(updateSearch({ search: values, pageId: searchPageId }));
    },
  });
  const headLabels = [
    { id: "count", label: "#", align: "center" },
    { id: "name", label: "Name" },
    { id: "group", label: "Group Name" },
    { id: "is_active", label: "Active" },
    { id: "created_at", label: "Created At" },
    { id: "" },
  ];
  const handleState = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const loadRecords = (search_rec) => {
    loadTableRecords({
      handleState,
      url: "/web-source-url/listing/",
      search: search_rec ? search_rec : instanceSearch.values,
    });
  };

  useEffect(() => {
    if (search.pageId === searchPageId) {
      instanceSearch.setValues(search.search);
      loadRecords(search.search ? search.search : instanceSearch.values);
    } else {
      loadRecords(searchInitialValues);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.search]);

  return (
    <Container>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Typography variant="h4">Static URL's</Typography>
        <Button
          variant="contained"
          component={RouterLink}
          href="/static-urls/manage/"
          color="inherit"
          startIcon={<Iconify icon="eva:plus-fill" />}
        >
          Create Static Url
        </Button>
      </Stack>
      <CustomTable
        instanceSearch={instanceSearch}
        rowCount={state.tcount}
        headLabel={headLabels}
        loading={state.loading}
        hasRecords={state.records && state.records.length > 0}
        query={instanceSearch.values.search}
        tableBody={
          <>
            {state.records &&
              !state.loading &&
              state.records.map((tableRow, index) => (
                <CustomTableRow
                  key={index}
                  row={tableRow}
                  index={
                    instanceSearch.values.page * instanceSearch.values.limit +
                    index +
                    1
                  }
                  loadRecords={loadRecords}
                  tableCells={
                    <>
                      <TableCell component="th" scope="row">
                        <Link
                          to={`/static-urls/${tableRow["id"]}/details/`}
                          style={{ textDecoration: "none", color: "inherit" }}
                          onClick={() => {
                            localStorage.setItem(
                              "from_page",
                              window.location.pathname
                            );
                          }}
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ ...textHover }}
                            >
                              {tableRow["name"]}
                            </Typography>
                          </Stack>
                        </Link>
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" gap={1}>
                          {(tableRow?.websource_group || []).map((group) => (
                            <Typography key={group.id} variant="subtitle2">
                              {group.name}
                            </Typography>
                          ))}
                        </Stack>
                      </TableCell>
                      <TableCell>
                        <Label
                          color={
                            (tableRow?.is_active === false && "error") ||
                            "success"
                          }
                        >
                          {tableRow?.is_active ? "Yes" : "No"}
                        </Label>
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" gap={1}>
                          {dateFormatter(tableRow?.created_at)}{" "}
                          {dayjs(tableRow?.created_at).format("hh:mm A")}
                        </Stack>
                      </TableCell>
                    </>
                  }
                  tableMenus={
                    <>
                      <MenuItem
                        component={RouterLink}
                        href={`/static-urls/${tableRow["id"]}/details/`}
                      >
                        <Iconify icon="eva:eye-fill" sx={{ mr: 2 }} /> View More
                      </MenuItem>
                      <MenuItem
                        component={RouterLink}
                        href={`/static-urls/manage/${tableRow["id"]}/`}
                      >
                        <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} /> Edit
                      </MenuItem>
                    </>
                  }
                  deleteUrl={`/web-source-url/delete/${tableRow["id"]}/`}
                />
              ))}
          </>
        }
      />
    </Container>
  );
}
